import { Component, Input } from '@angular/core';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendForm } from '../../netgen/FrontendForm';

@Component({
    selector: 'app-sm-form-group',
    templateUrl: './sm-form-group.component.html',
    styleUrl: './sm-form-group.component.scss',
    standalone: false
})
export class SmFormGroupComponent {

    @Input()
    form: FrontendForm = null;
    @Input()
    fields: FrontendField[][] = [];
    @Input()
    fullHeight = false;
}
